var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _c("label", { staticClass: "label-description", class: _vm.labelClasses }, [
      _vm._v(" " + _vm._s(_vm.title)),
    ]),
    _c(
      "div",
      [
        _vm._t(
          "default",
          function () {
            return [
              _c(
                "div",
                { staticClass: "description", class: _vm.valueClasses },
                [_vm._v(_vm._s(_vm.value))]
              ),
            ]
          },
          { value: _vm.value }
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }